// 正式
// const VUE_APP_WS_URL = "wss://api.aurexsx.com/websocket";
// const VUE_APP_BASEURL = ""https://api.aurexsx.com";
// 测试
const VUE_APP_WS_URL = "wss://api.aurexsx.com/websocket";
const VUE_APP_BASEURL = "https://api.aurexsx.com";
// 本地
// const VUE_APP_WS_URL = "ws://192.168.0.53:8086/websocket";
// const VUE_APP_BASEURL = "http://192.168.0.53:8086";

export { VUE_APP_WS_URL, VUE_APP_BASEURL };
